import { RefObject, useEffect } from 'react';

import { useSidebar } from '../contexts/SidebarContext/hook';

export const useUpdateHeaderHeight = (headerRef: RefObject<HTMLElement>): void => {
  const { handleHeaderHeightChange } = useSidebar();

  useEffect(() => {
    if (headerRef.current) {
      const observer = new ResizeObserver((entries) => {
        for (const entry of entries) {
          handleHeaderHeightChange(entry.contentRect.height);
        }
      });

      observer.observe(headerRef.current);

      return () => {
        observer.disconnect();
      };
    }
  }, [headerRef.current, handleHeaderHeightChange]);
};
